export default __webpack_public_path__ + "static/empty-cart-ee2eb22ee3cf539526db2cfaf529eae2.webp";